import { Webhook } from "callable-data-objects";
import { useWebhook } from "Hooks/Endpoints";
import React from "react";
import { Button, Form, Label, Table } from "semantic-ui-react";

const PluginSelect = ({ field, form, label, select, ...props }: any) => {
  const { hooks } = useWebhook();

  async function connect(newHook: Webhook) {
    form.setFieldValue(field.name, newHook.id);
  }

  return (
    <Form.Field>
      <label>Select Hook</label>
      <Table celled padded stackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1} singleLine></Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              Hook Application
            </Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              URL
            </Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              Auth Type
            </Table.HeaderCell>
            <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {hooks
            .filter((h: Webhook) => h.app.indexOf("ivr") > -1 || h.app === "ViVa-D2C")
            .map((h: Webhook) => (
              <Table.Row key={`tr-${h.id}`}>
                <Table.Cell singleLine>
                  {h.id === field.value ? (
                    <Label color="blue" ribbon>
                      Selected
                    </Label>
                  ) : (
                    ""
                  )}
                </Table.Cell>
                <Table.Cell singleLine>{h.app}</Table.Cell>
                <Table.Cell singleLine>{h.url}</Table.Cell>

                <Table.Cell singleLine>{h.authType}</Table.Cell>
                <Table.Cell singleLine>
                  {h.id !== field.value && (
                    <Button
                      as="button"
                      size="tiny"
                      color="blue"
                      onClick={() => connect(h)}
                    >
                      Select
                    </Button>
                  )}
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    </Form.Field>
  );
};

export default PluginSelect;
